module.exports = __webpack_public_path__ + "da6899a8a915939894190422ed3b4b71.jpg";